import React from "react";
import { RotatingTriangles } from "react-loader-spinner";

export default function Loader() {
  return (
    <div className="container my-5 d-flex align-items-center justify-content-center">
      <RotatingTriangles type="Oval" color="#00BFFF" height={50} width={50} />
    </div>
  );
}
